<template>
	<transition name="content-fade">
		<div class="main_container"
		     :class="classParameter">
			<div class="parameter">{{getParameters}}</div>
			<div class="content">
				<form class="type_uid"
				      @keyup.enter.prevent="submit">
					<div>
						<label for="select">type</label>
						<select id="select">
							<option v-for="el in option"
							        :key="el"
							        :value="el">{{el}}
							</option>
						</select>
					</div>
					<div>
						<label for="uid">uid
							<transition name="autocompletes">
								<div id="autocomplete"
								     v-if="autocompleteShow">
									<p v-for="el in getAutocompleteFilter"
									   @click="select" :key="el">{{el}}</p>
								</div>
							</transition>
						</label>
						<input id="uid"
						       placeholder="login-MAC"
						       autocomplete="off"
						       :disabled="showA"
						       @keyup="autocomplete"/>
					</div>
				</form>
				<form class="from_to">
					<div>
						<label for="from">from</label>
						<input type="datetime-local"
						       id="from"
						       :value="dateFrom"/>
					</div>
					<div>
						<label for="to">to</label>
						<input type="datetime-local"
						       id="to"
						       :value="dateTo"/>
					</div>
				</form>
				<form action=""
				      class="filter"
				      @submit.prevent="submit">
					<div>
						<label for="request">filter</label>
						<div>
							<input type="text"
							       id="request"
							       placeholder="filter"
							       autocomplete="off"
							       v-model="inputFilter"
							       @keyup="inputFilter !== '' ? showA = true : showA = false; autocompleteShow = false"
							       :disabled="getShowFilter"/>
							<input type="submit">
						</div>
					</div>
					<transition name="modal">
						<div class="modal"
						     :class="{show: getModalWindow}">нет таких данных!
						</div>
					</transition>
				</form>
			</div>
			<button @click="hiddenSearch">
				<span :class="classRotate"></span>
			</button>
		</div>
	</transition>
</template>
<script>
	import moment                                   from "moment";
	import { mapGetters, mapActions, mapMutations } from "vuex";
	import { performRequest }                       from "../script/ws/wsclient";

	export default {
		name:     "parameters",
		data() {
			return {
				option:           {},
				data:             {
					command: {
						section: "iptvlog",
						name:    "getUserList"
					},
					data:    {
						dateFrom: Date.parse(`${new Date()}`) / 1000 - 3600,
						dateTo:   Date.parse(`${new Date()}`) / 1000,
						uid:      "",
						operator: ""
					},
				},
				dateTo:           moment(new Date()).format("YYYY-MM-DDTHH:mm"),
				dateFrom:         moment(
					new Date(Date.parse(`${new Date()}`) - 3600 * 1000)
				).format("YYYY-MM-DDTHH:mm"),
				autocompleteShow: false,
				autocomp:         [],
				showA:            false,
				inputFilter:      "",
			};
		},
		created() {
			this.data.data.operator = this.getViewUser;
			this.option             = this.getOptionForParameters;
			performRequest(
				{
					section: "iptvlog",
					name:    "getUserList"
				},
				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						a.data.forEach(el => {
							this.autocomp.push(el.uid);

						});
						this.setAutocomplete(this.autocomp);
					} else if (a.code === 413) {
						console.log("Ответ слишком большой!");
					} else {
						console.log("ошибка при получении ответа!");
					}

				}
			);
		},
		updated() {
			this.option = this.getOptionForParameters;
		},
		computed: {
			...mapGetters([
				"getParameters",
				"getHiddenParameters",
				"getCycle",
				"getOptionForParameters",
				"getShowFilter",
				"getAutocomplete",
				"getAutocompleteFilter",
				"getLoad",
				"getModalWindow",
				"getViewUser"
			]),
			classParameter() {
				return this.getHiddenParameters ? "hidden" : null;
			},
			classRotate() {
				return this.getHiddenParameters ? "rotate" : null;
			},
			selectedIndex() {
				return document.querySelector("select").selectedIndex;
			}
		},
		methods:  {
			...mapActions([
				"setHiddenParameters",
				"setArray",
				"setCycle",
				"setFilter"
			]),
			...mapMutations([
				"deleteArray",
				"setAutocompleteFilter",
				"deleteAutocompleteFilter",
				"setLoad",
				"setModalWindow",
				"setAutocomplete",
				"setTooLargePayload",
				"setEmptyPayload",
				"setIncorrectData"
			]),
			hiddenSearch() {
				this.setHiddenParameters(!this.getHiddenParameters);
				this.autocompleteShow = false;
				this.setTooLargePayload(false);
				this.setEmptyPayload(false);
				this.setIncorrectData(false)
			},
			submit() {
				document.documentElement.scrollTop = 0;
				this.autocompleteShow              = false;
				this.setLoad(true);
				if (!document.querySelector("#request").value) {
					this.setCycle(0);
					this.deleteArray();
					this.data.command.name = document.querySelector(
						"#select"
					).options[
						document.querySelector("#select").selectedIndex
						].value;
					this.setHiddenParameters(!this.getHiddenParameters);
					this.data.data.dateTo   =
						Date.parse(document.querySelector("#to").value) / 1000;
					this.data.data.dateFrom =
						Date.parse(document.querySelector("#from").value) / 1000;
					this.data.data.uid      = document
						.querySelector("#uid")
						.value
						.split("\r\t\n")
						.toString();
					if (this.data.command.name === "getUserList") {
						let arr = {
							command: {
								section: "iptvlog",
								name:    "getUserList"
							},
							data:    {
								operator: this.getViewUser
							},
						};
						if (document.querySelector("#uid").value === "") {
							this.setArray(arr);
						} else {
							arr.data.uid = document.querySelector("#uid").value;
							this.setArray(arr);
						}
					} else {
						this.setArray(this.data);
					}
					this.$router.push("/menu/parameters/table");
				} else {
					this.setFilter(document.querySelector("#request").value);
					document.querySelector("#request").value = "";
					this.setHiddenParameters(!this.getHiddenParameters);
				}
				document.querySelector("#uid").value = "";
				this.inputFilter                     = "";
				this.showA                           = false;
			},
			autocomplete(e) {
				if (e.target.value.length >= 4) {
					this.deleteAutocompleteFilter();
					this.setAutocompleteFilter(e.target.value);
					this.getAutocompleteFilter.length > 0
						? ( this.autocompleteShow = true )
						: ( this.autocompleteShow = false );
				} else {
					this.deleteAutocompleteFilter();
					this.autocompleteShow = false;
				}
			},
			select(e) {
				document.querySelector("#uid").value = e.target.textContent;
				this.autocompleteShow                = false;
			},
		},
		watch:    {
			"$store.state.modalWindow"() {
				setTimeout(() => {
					this.setModalWindow(false);
				}, 2000);
			}
		}
	};
</script>
<style scoped lang="scss">
	button {
		height: 2rem;
		background-color: transparent;
		outline: none;
		border: none;
		cursor: pointer;
		z-index: 100;
		
		span {
			display: block;
			margin: 0 auto;
			height: 2rem;
			width: 2rem;
			background: transparent url('../../static/arrow.png') no-repeat center;
			background-size: 100%;
			transform: rotate(-180deg);
			transition: all 0.3s;
		}
	}
	.rotate {
		transform: rotate(0);
	}
	.parameter {
		margin: 0 auto;
		font-weight: bold;
		padding: 0.5rem;
	}
	.main_container {
		z-index: 150;
		position: fixed;
		right: 0;
		left: 0;
		width: 80rem;
		margin: 4rem auto;
		display: flex;
		flex-direction: column;
		background-color: rgba(238, 238, 238, 0.8);
		border-radius: 0.5rem;
		box-shadow: inset 0 0 5px #333333;
		transition: all 0.2s;
		
		.content {
			display: flex;
			margin: 0 auto;
		}
	}
	input, select {
		width: 20rem;
		height: 2rem;
		margin-right: 0;
		border-radius: 3px;
		outline: none;
		border: 1px solid #c9c9c9;
		padding-left: 5px;
		
		&:focus {
			box-shadow: 0 0 5px #69bf8f;
		}
	}
	form {
		div {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin: 1rem 0;
		}
	}
	.from_to, .filter {
		label {
			margin: 0 1rem 0 2rem;
		}
	}
	.filter {
		position: relative;
		
		div {
			div {
				display: flex;
				flex-direction: column;
				
				input[type='text'] {
					margin: -1rem 0 1rem 0;
				}
				
				input[type='submit'] {
					background: #bbf291;
					transition: all 0.2s;
					cursor: pointer;
					
					&:hover {
						background: #78956b;
						color: white;
						
						&:active {
							box-shadow: 0 0 1rem #967068;
						}
					}
				}
			}
		}
		
		.modal {
			position: absolute;
			top: 2px;
			left: 10rem;
			color: red;
			display: none;
			font-weight: bold;
		}
		
		.show {
			display: block;
		}
	}
	.type_uid {
		label {
			position: relative;
			margin: 0 1rem 0 1rem;
		}
	}
	.hidden {
		margin-top: -7rem;
	}
	#autocomplete {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		top: 2rem;
		left: 2.95rem;
		height: 10rem;
		background-color: rgba(210, 215, 238, 0.9);
		border: 1px solid #ccc;
		border-radius: 0.3rem;
		box-shadow: inset 0 0 2px #333333;
		width: 20rem;
		overflow: auto;
		padding-left: 0.5rem;
		z-index: 10000;
		
		p {
			display: block;
			margin: 0.2rem;
			cursor: pointer;
		}
	}
	@media (max-width: 1120px) {
		.main_container {
			width: 60rem;
		}
		
		.hidden {
			margin-top: -10rem;
		}
		
		.content {
			flex-wrap: wrap;
			justify-content: space-around;
		}
		
		.filter {
			width: 90%;
			display: flex;
			justify-content: space-between;
			
			label {
				margin: 0 0.8rem;
			}
			
			div {
				margin-top: 0;
				
				div {
					width: 700px;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					
					input[type='submit'] {
						margin-right: -0.65rem;
					}
					
					input[type='text'] {
						margin: 0;
					}
				}
			}
		}
		
		#autocomplete {
			left: 2.95rem;
		}
	}
	@media (max-width: 850px) {
		.main_container {
			width: 30rem;
		}
		
		.hidden {
			margin-top: -20rem;
		}
		
		.type_uid, .from_to {
			width: 25rem;
			
			label {
				margin: 0;
			}
		}
		
		.filter {
			label {
				margin: 0 1rem 0 -1.3rem;
			}
			
			div {
				margin-top: 0;
				
				div {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					margin-left: 2rem;
					
					input[type='text'] {
						margin-bottom: 1rem;
					}
				}
			}
		}
		
		div {
			width: 25rem;
			display: flex;
			justify-content: space-between;
			
			label {
				margin: 0;
			}
			
			input {
				width: 20rem;
			}
		}
		
		#autocomplete {
			left: 5rem;
		}
	}
	@media (max-width: 620px) {
		.main_container {
			width: 21rem;
			margin-top: 8rem;
		}
		
		.hidden {
			margin-top: -16rem;
		}
		
		.type_uid, .from_to {
			margin-left: -2.1rem;
			width: 20rem;
			
			div {
				width: 100%;
				
				input, select {
					width: 15rem;
					margin-right: 1.2rem;
				}
			}
			
			label {
				margin: 0;
			}
		}
		
		.filter {
			div {
				width: 20rem;
				display: flex;
				justify-content: space-between;
				
				label {
					margin: 0;
				}
				
				input, select {
					width: 15rem;
				}
			}
		}
		
		#autocomplete {
			left: 3.85rem;
			width: 15rem;
		}
	}
	.content-fade-enter-active {
		transition: all 0.3s ease;
	}
	.content-fade-leave-active {
		transition: all 0.3s ease;
	}
	.content-fade-enter, .content-fade-leave-to {
		opacity: 0;
	}
	.autocompletes-fade-enter-active {
		transition: all 1s ease;
	}
	.autocompletes-fade-leave-active {
		transition: all 1s ease;
	}
	.autocompletes-fade-enter, .autocompletes-fade-leave-to {
		opacity: 0;
	}
	.modal-enter-active {
		transition: all 1s ease;
	}
	.modal-leave-active {
		transition: all 1s ease;
	}
	.modal-enter, .modal-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Parameters.vue